import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=6405d0be"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6405d0be')) {
      api.createRecord('6405d0be', component.options)
    } else {
      api.reload('6405d0be', component.options)
    }
    module.hot.accept("./AdminHeader.vue?vue&type=template&id=6405d0be", function () {
      api.rerender('6405d0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminHeader.vue"
export default component.exports